import * as React from 'react';
import PropTypes from 'prop-types';
// material
import { Modal, Box, Typography, Stack } from '@mui/material';
import Iconify from '../../components/iconify';
// -------------------------------------------------------------------------------------------------

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'grey.200',
    width: 320,
    height: 230,
    display: 'flex',
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 1.5,
};

ProgressBarPopup.propTypes = {
    msg: PropTypes.string,
};

export default function ProgressBarPopup({ msg }) {

    const handleClose = () => {
        //    openCloseValue(false);
    };
    let content;

    if (msg === "NO") {
        content = "Please wait ....";
    } else if (msg === "") {
        content = "Please wait, we are updating the data...";
    } else {
        content = msg.toString();
      //  console.log("msg", msg.toString());
    }

    return (
        <div>
            <Modal
                open
                onClose={handleClose}
            >
                <Box sx={style}>
                    <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                        <Iconify icon="svg-spinners:bars-rotate-fade" width={70} height={70} />

                        <Typography variant="body2">{content}
                        </Typography>

                    </ Stack>
                </Box>
            </Modal>
        </div >
    );
}